(function() {
  window.streamerDisplayModeService = {
    /**
     * Get streamer's display mode preference for a channel
     * @param {string} channelId - The channel ID
     * @returns {Promise} - Response with displayMode ('broadcast' or 'extension')
     */
    get(channelId) {
      return axios.get(`/api/obs/display-mode.php?channelId=${encodeURIComponent(channelId)}`);
    },

    /**
     * Save streamer's display mode preference
     * @param {Object} data - { channelId, displayMode }
     * @returns {Promise} - Success response
     */
    save(data) {
      return axios.post('/api/obs/display-mode.php', data);
    },

    /**
     * Validate display mode value
     * @param {string} mode - The mode to validate
     * @returns {boolean} - True if valid
     */
    isValidMode(mode) {
      return ['broadcast', 'extension'].includes(mode);
    },

    /**
     * Get human-readable label for display mode
     * @param {string} mode - The display mode
     * @returns {string} - Friendly label
     */
    getLabel(mode) {
      const labels = {
        'broadcast': '📺 Show on OBS Broadcast',
        'extension': '🔒 Extension Only (Hidden from OBS)'
      };
      return labels[mode] || mode;
    },

    /**
     * Get description for display mode
     * @param {string} mode - The display mode
     * @returns {string} - Description text
     */
    getDescription(mode) {
      const descriptions = {
        'broadcast': 'Pack animations display on your stream for all viewers to see',
        'extension': 'Pack animations only appear in the Twitch extension, hidden from OBS'
      };
      return descriptions[mode] || '';
    }
  }
})();
